import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { Form } from '../form.component';
import { FormCallbacks } from '../formUtils';

export class FastActionNetworkForm extends PureComponent {
  static propTypes = {
    hostWindow: PropTypes.object,
    onFormRendered: PropTypes.func,
    onSubmit: PropTypes.func,
    submitted: PropTypes.bool,
  };

  componentDidMount() {
    this.initFormCallbacks();
  }

  initFormCallbacks() {
    const callbacks = new FormCallbacks(this.props.hostWindow);

    callbacks.add('preSegue', this.props.onSubmit);
    callbacks.add('postFill', this.props.onFormRendered);
  }

  render = () => !this.props.submitted ? <Form {...this.props} /> : null;
}
